import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Entity} from '../../../../services/global/global-interfaces';

@Component({
  selector: 'app-device-attachments',
  templateUrl: './device-attachments.component.html',
  styleUrls: ['./device-attachments.component.scss'],
  standalone: false,
})
export class DeviceAttachmentsComponent implements OnInit {
  entity: Entity;
  show: boolean;

  deviceId: number;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      if (params.deviceID) {
        this.deviceId = +params.deviceID;
        this.entity = {
          entity: 'device',
          entityId: this.deviceId,
        };
        this.show = true;
      }
    });
  }
}
